module.exports = __webpack_public_path__ + "static/media/Bellatrix Lestrange 2.be27ae98.jpg";